import { render, staticRenderFns } from "./AuthBtn.vue?vue&type=template&id=5921f610&"
import script from "./AuthBtn.vue?vue&type=script&lang=ts&"
export * from "./AuthBtn.vue?vue&type=script&lang=ts&"
import style0 from "./AuthBtn.vue?vue&type=style&index=0&id=5921f610&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QBtn});
